import { useState, useRef, useEffect, useCallback } from 'react';
import '../styles/player.css';

function GenreSelector({ genres, selectedGenres, onSelectionChange, popupDirection = 'up', popupAlign = 'left' }) {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);
  const buttonRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (
        popupRef.current && !popupRef.current.contains(e.target) &&
        buttonRef.current && !buttonRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('pointerdown', handleClick);
    return () => document.removeEventListener('pointerdown', handleClick);
  }, [isOpen]);

  const handleToggleGenre = useCallback((genre) => {
    const next = new Set(selectedGenres);
    if (next.has(genre)) {
      next.delete(genre);
    } else {
      next.add(genre);
    }
    onSelectionChange(next);
  }, [selectedGenres, onSelectionChange]);

  const handleSelectAll = useCallback(() => {
    onSelectionChange(new Set());
  }, [onSelectionChange]);

  const isAllSelected = selectedGenres.size === 0;
  const label = isAllSelected
    ? 'All'
    : selectedGenres.size === 1
      ? [...selectedGenres][0]
      : `${selectedGenres.size} genres`;

  return (
    <div className="genre-selector-wrapper">
      <button
        ref={buttonRef}
        className={`player-mode-btn ${!isAllSelected ? 'active' : ''}`}
        onClick={() => setIsOpen((v) => !v)}
        title={isAllSelected ? 'Showing all recommendations — click to filter by genre' : `Filtered to: ${[...selectedGenres].join(', ')}`}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
        <span className="player-mode-label">{label}</span>
        <svg className="genre-selector-caret" viewBox="0 0 12 12" fill="currentColor" width="8" height="8">
          <path d="M2 4l4 4 4-4" />
        </svg>
      </button>

      {isOpen && (
        <div ref={popupRef} className={`genre-selector-popup genre-selector-popup-${popupDirection} genre-selector-popup-align-${popupAlign}`}>
          <button
            className={`genre-selector-item ${isAllSelected ? 'selected' : ''}`}
            onClick={handleSelectAll}
          >
            <span className="genre-selector-check">{isAllSelected ? '✓' : ''}</span>
            All
          </button>
          {genres.map((genre) => (
            <button
              key={genre}
              className={`genre-selector-item ${selectedGenres.has(genre) ? 'selected' : ''}`}
              onClick={() => handleToggleGenre(genre)}
            >
              <span className="genre-selector-check">{selectedGenres.has(genre) ? '✓' : ''}</span>
              {genre}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default GenreSelector;
